import accessToken from "./access-token/index.js";
import refreshToken from "./refresh-token/index.js";
import csrf from "./csrf/index.js";
import login from "./login.js";

export default {
	accessToken,
	refreshToken,
	csrf,
	login,
};
